import {createStore} from 'vuex'
import userTab from './userTab'
import others from './others'
export default createStore({
    modules: {
        userTab,
        others
    }
})